import { TextField } from '@material-ui/core';
import cls from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { useTextAreaStyles } from './styles';

const TextArea = ({ className, helpText, ...props }) => {
  const classes = useTextAreaStyles();
  return (
    <TextField
      rows={4}
      {...props}
      helperText={helpText}
      classes={{
        root: cls(classes.root, className),
      }}
      InputProps={{
        classes: {
          underline: classes.focused,
          focused  : classes.focused,
        },
      }}
      multiline
    />
  );
};

TextArea.propTypes = {
  className: PropTypes.string,
  helpText : PropTypes.string,
};

TextArea.defaultProps = {
  className: undefined,
  helpText : '',
};

export default TextArea;
